<template>
  <div class="product__cans-flavour-row__inner">
    <slot />
  </div>
</template>

<script>
import { initCansSiblingDelegation } from '../../helpers/cans-sibling-swap'

export default {
  name: 'CansFlavourRow',

  mounted () {
    initCansSiblingDelegation()
  }
}
</script>
